import React, { useContext, useEffect, useState } from 'react'
import Web3context from '../contexts/Web3context.js'

import abi_1155 from '../contracts/IERC1155Game.json'

const BidItem = (props) => {
  // if no data redirect to ingredients
  if (!props.location.data) {
    window.location = "/ingredients"
  }

  // Call web3 model init
  const web3context = useContext(Web3context)
  let { getWeb3 } = web3context;

  // Fetch highest Bid from smart contract
  const [currentBid, setCurrentBid] = useState(0);
  useEffect(() => {
    const getBid = async () => {
      try {
        const web3 = getWeb3;
        const item = props.location.data;

        // console.log(await web3.eth.net.getId());
        // const accounts = await web3.eth.getAccounts();
        const contract_1155 = await new web3.eth.Contract(abi_1155.abi, "0xebe32c46234cA88A373a42Ed3916a7222B3E6BB0");
        const info = await contract_1155.methods.getHighestBid(item.id).call();
        console.log(info.message);
        setCurrentBid(info.message);
      } catch (err) {
        console.log(err)
      }
    }
    getBid()
  }, [getWeb3, props.location.data])

  // user bid
  const [userBid, setUserBid] = useState(0);

  // Buy Item directly
  const bidItem = async () => {
    try {
      const web3 = getWeb3;
      const item = props.location.data;

      // console.log(await web3.eth.net.getId());
      const accounts = await web3.eth.getAccounts();
      const contract_1155 = await new web3.eth.Contract(abi_1155.abi, "0xebe32c46234cA88A373a42Ed3916a7222B3E6BB0");

      const txnhash = await contract_1155.methods.buyIngredientNFT(item.id, item.tname)
        .send({ from: accounts[0], gasPrice: "1000000000", gas: 35000 });
      console.log(txnhash)
    } catch (err) {
      console.log(err);
    }
  }

  // stakeBid Raise the bid 
  const stakeBid = async () => {
    try {
      const web3 = getWeb3;
      const item = props.location.data;

      // console.log(await web3.eth.net.getId());
      const accounts = await web3.eth.getAccounts();
      const contract_1155 = await new web3.eth.Contract(abi_1155.abi, "0xebe32c46234cA88A373a42Ed3916a7222B3E6BB0");

      const txnhash = await contract_1155.methods.placeBid(item.id, userBid)
        .send({ from: accounts[0], gasPrice: "1000000000", gas: 35000 });
      console.log(txnhash)
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <React.Fragment>
      <div className="productDetails_page">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="productImages">
                <img src="assets/images/tomato-big.svg" alt="" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="productContent">
                <h1>{props.location.data.name}</h1>
                <h4>BID ENDS IN TIMER</h4>
                <h3>CURRENT BID : {currentBid}</h3>
                <h2>DESCRIPTION</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                </p>
                <button onClick={bidItem}>Buy now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="diddingHistorySections">
        <div className="Ingradient_tabs">
          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" data-toggle="tab" href="#stakeTabs" role="tab">ADDRESS</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#unlockTabs" role="tab">BID</a>
            </li>
          </ul>
          <div className="tab-content">
            <div className="tab-pane active" id="stakeTabs" role="tabpanel">
              <div className="addressBidSection">
                <ol>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ol>
              </div>

              <div className="apyBootSection">
                <h2>RAISE BID TO : <input type="text" /> + </h2>
                <button>Stake</button>
              </div>

              <div className="biddingRelesSection">
                <h3>BIDDING RULES</h3>
                <ol>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ol>
              </div>

            </div>
            <div className="tab-pane" id="unlockTabs" role="tabpanel">
              <div className="addressBidSection">
                <ol>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ol>
              </div>

              <div className="apyBootSection">
                <h2>RAISE BID TO : <input value={userBid} onChange={(e) => setUserBid(e.target.value)} type="text" /> + </h2>
                <button onClick={stakeBid}>Stake</button>
              </div>

              <div className="biddingRelesSection">
                <h3>BIDDING RULES</h3>
                <ol>
                  <li></li>
                  <li></li>
                </ol>
              </div>

            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default BidItem
